/**
 * @flow
 * @relayHash a87169fe42adc97e5c0c180bde395acf
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ContractTemplateContainer_node$ref = any;
export type DeleteCTemplateLineItemInput = {
  clientMutationId?: ?string,
  id: string,
};
export type LineItems_ContractTemplate_deleteCTemplateLineItemMutationVariables = {|
  input: DeleteCTemplateLineItemInput
|};
export type LineItems_ContractTemplate_deleteCTemplateLineItemMutationResponse = {|
  +deleteCTemplateLineItem: ?{|
    +deletedCTemplateLineItemId: ?string,
    +c_template: ?{|
      +$fragmentRefs: ContractTemplateContainer_node$ref
    |},
  |}
|};
export type LineItems_ContractTemplate_deleteCTemplateLineItemMutation = {|
  variables: LineItems_ContractTemplate_deleteCTemplateLineItemMutationVariables,
  response: LineItems_ContractTemplate_deleteCTemplateLineItemMutationResponse,
|};
*/


/*
mutation LineItems_ContractTemplate_deleteCTemplateLineItemMutation(
  $input: DeleteCTemplateLineItemInput!
) {
  deleteCTemplateLineItem(input: $input) {
    deletedCTemplateLineItemId
    c_template {
      ...ContractTemplateContainer_node
      id
    }
  }
}

fragment ContractTemplateContainer_node on CTemplate {
  id
  title
  terms
  brand {
    id
    logo_url
    header
  }
  c_template_line_items(first: 99999) {
    edges {
      node {
        id
        description
        position
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  c_template_signature_blocks(first: 99999) {
    edges {
      node {
        id
        address_visibility
        company_name_visibility
        email_visibility
        name_visibility
        phone_visibility
        signing_party
        title_visibility
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteCTemplateLineItemInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "DeleteCTemplateLineItemInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "deletedCTemplateLineItemId",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v5 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }
],
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "LineItems_ContractTemplate_deleteCTemplateLineItemMutation",
  "id": null,
  "text": "mutation LineItems_ContractTemplate_deleteCTemplateLineItemMutation(\n  $input: DeleteCTemplateLineItemInput!\n) {\n  deleteCTemplateLineItem(input: $input) {\n    deletedCTemplateLineItemId\n    c_template {\n      ...ContractTemplateContainer_node\n      id\n    }\n  }\n}\n\nfragment ContractTemplateContainer_node on CTemplate {\n  id\n  title\n  terms\n  brand {\n    id\n    logo_url\n    header\n  }\n  c_template_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  c_template_signature_blocks(first: 99999) {\n    edges {\n      node {\n        id\n        address_visibility\n        company_name_visibility\n        email_visibility\n        name_visibility\n        phone_visibility\n        signing_party\n        title_visibility\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "LineItems_ContractTemplate_deleteCTemplateLineItemMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "deleteCTemplateLineItem",
        "storageKey": null,
        "args": v1,
        "concreteType": "DeleteCTemplateLineItemPayload",
        "plural": false,
        "selections": [
          v2,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "c_template",
            "storageKey": null,
            "args": null,
            "concreteType": "CTemplate",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "ContractTemplateContainer_node",
                "args": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "LineItems_ContractTemplate_deleteCTemplateLineItemMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "deleteCTemplateLineItem",
        "storageKey": null,
        "args": v1,
        "concreteType": "DeleteCTemplateLineItemPayload",
        "plural": false,
        "selections": [
          v2,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "c_template",
            "storageKey": null,
            "args": null,
            "concreteType": "CTemplate",
            "plural": false,
            "selections": [
              v3,
              v4,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "terms",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "brand",
                "storageKey": null,
                "args": null,
                "concreteType": "Brand",
                "plural": false,
                "selections": [
                  v3,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "logo_url",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "header",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "c_template_line_items",
                "storageKey": "c_template_line_items(first:99999)",
                "args": v5,
                "concreteType": "CTemplateLineItemConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CTemplateLineItemEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CTemplateLineItem",
                        "plural": false,
                        "selections": [
                          v3,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "description",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "position",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "price_cents",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "price_currency",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "quantity",
                            "args": null,
                            "storageKey": null
                          },
                          v4,
                          v6
                        ]
                      },
                      v7
                    ]
                  },
                  v8
                ]
              },
              {
                "kind": "LinkedHandle",
                "alias": null,
                "name": "c_template_line_items",
                "args": v5,
                "handle": "connection",
                "key": "ContractTemplateContainer_c_template_line_items",
                "filters": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "c_template_signature_blocks",
                "storageKey": "c_template_signature_blocks(first:99999)",
                "args": v5,
                "concreteType": "CTemplateSignatureBlockConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CTemplateSignatureBlockEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CTemplateSignatureBlock",
                        "plural": false,
                        "selections": [
                          v3,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "address_visibility",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "company_name_visibility",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "email_visibility",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "name_visibility",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "phone_visibility",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "signing_party",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "title_visibility",
                            "args": null,
                            "storageKey": null
                          },
                          v6
                        ]
                      },
                      v7
                    ]
                  },
                  v8
                ]
              },
              {
                "kind": "LinkedHandle",
                "alias": null,
                "name": "c_template_signature_blocks",
                "args": v5,
                "handle": "connection",
                "key": "ContractTemplateContainer_c_template_signature_blocks",
                "filters": null
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b06c0b6c9208b0f69571bf84e7da2cd7';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Document/Template/Contract/__generated__/LineItems_ContractTemplate_deleteCTemplateLineItemMutation.graphql.js